// IANA time-zone picker for a site. A site's day boundaries, "today" and
// "this month" are on ITS wall clock, which is why the zone is part of the
// site and not taken from whoever happens to be looking at it.
import { useMemo } from "react";
import { timeZoneList } from "../lib/format";

export function TimeZoneSelect({
  id,
  value,
  onChange,
}: {
  id?: string;
  value: string;
  onChange: (tz: string) => void;
}) {
  const zones = useMemo(() => {
    const list = timeZoneList();
    // Keep a stored zone this browser does not list selectable as-is.
    return value && !list.includes(value) ? [value, ...list] : list;
  }, [value]);
  return (
    <select id={id} className="input mt-1" value={value} onChange={(e) => onChange(e.target.value)}>
      {zones.map((z) => (
        <option key={z} value={z}>
          {z.replace(/_/g, " ")}
        </option>
      ))}
    </select>
  );
}
